import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { agentChat } from '../services/agentApi';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './ResearchPage.css';

const AgentCategoryPage = () => {
  const { slug } = useParams();
  useDocumentTitle(slug ? `${slug} · Agents` : 'Agents');
  const [message, setMessage] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChat = async () => {
    if (!message.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const data = await agentChat(slug, message.trim(), sessionId);
      setSessionId(data.sessionId);
      setResponse(data);
      setMessage('');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="research-page">
      <div className="container">
        <h1>{slug} agent</h1>
        <div className="research-panel article-creation">
          <div className="search-form">
            <input
              className="form-control"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ask a question…"
              onKeyDown={(e) => e.key === 'Enter' && handleChat()}
            />
            <button className="btn btn-primary" onClick={handleChat} disabled={loading}>
              {loading ? 'Thinking…' : 'Send'}
            </button>
          </div>
          {error && <p className="research-error">{error}</p>}
          {response?.response && (
            <div className="agent-response">
              <ReactMarkdown>{response.response}</ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentCategoryPage;
